import React from "react";
import { useLocation, useParams } from "react-router-dom";
import SensorBase from "../sensors/SensorBase";
import { t } from "../../../services/locale.service";

const Diseases: React.FC = () => {

  const { sensor } = useParams();
  const { state } = useLocation();

  const TabButtons = {
    week: t("1_Week"),
    month: t("1_Month"),
    year: t("1_Year")
  };

  const diseasePest = state.isDisease ? "Disease" : state.isPest ? "Pest" : undefined;
  return (
    <div>
      <SensorBase 
        field={sensor!} 
        unit="%" 
        tabButtons={TabButtons} 
        diseasePest={diseasePest}
      />
    </div>
  );
};

export default Diseases;



// this is an old code -- may not be use now
